var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurable-dialog"},[_c('div',{staticClass:"configurable-dialog__content",attrs:{"slot":"custom"},slot:"custom"},[_c('div',{directives:[{name:"stat",rawName:"v-stat",value:({
        id: 50022,
        args: {
          target: 'REDUCTION_INTEREST', // 免息活动
          step: _vm.data.nextStep,
          position: 1,
          status: _vm.mobile ? 1 : 0,
        },
      }),expression:"{\n        id: 50022,\n        args: {\n          target: 'REDUCTION_INTEREST', // 免息活动\n          step: data.nextStep,\n          position: 1,\n          status: mobile ? 1 : 0,\n        },\n      }"}],staticClass:"configurable-dialog__content__button",on:{"click":_vm.handleButtonClick}},[_vm._v("\n      立即领取\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"stat",rawName:"v-stat",value:({
        id: 50022,
        args: {
          target: 'REDUCTION_INTEREST', // 免息活动
          step: _vm.data.nextStep,
          position: 2,
          status: _vm.mobile ? 1 : 0,
        },
      }),expression:"{\n        id: 50022,\n        args: {\n          target: 'REDUCTION_INTEREST', // 免息活动\n          step: data.nextStep,\n          position: 2,\n          status: mobile ? 1 : 0,\n        },\n      }"}],staticClass:"configurable-dialog__content__text-button",on:{"click":_vm.handleTextButtonClick}},[_vm._v("\n      活动详情 >\n    ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }